// Api
import * as ReportsApi from "office/reports/activeListings/api";
//-------------------------------------------------------------------------------------------------------------------------------
export const FETCHING = "REPORT_OFFICE_FETCHING_ACTIVE_LISTINGS";
export const LOAD = "REPORT_OFFICE_ACTIVE_LISTINGS";
export function fetchingData(officeId, date) {
    return {
        type: FETCHING,
        officeId: officeId,
        date: date
    };
}
export function recievedData(report) {
    return {
        type: LOAD,
        report: report
    };
}
//-------------------------------------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------------------------------------
export const getForced = (officeId, date = null) => {
    return (dispatch) => {
        getActiveListings(dispatch, officeId, date);
    };
};
//-------------------------------------------------------------------------------------------------------------------------------
const getActiveListings = (dispatch, officeId, date = null) => {
    dispatch(fetchingData(officeId, date));
    ReportsApi.async_activeListingsRequest(dispatch, officeId, date)
        .then((report) => {
        dispatch(recievedData(report));
    }, (message) => {
        dispatch(recievedData({
            isFetching: false,
            officeId: officeId,
            officeName: "",
            date: date,
            items: []
        }));
    });
};
//-------------------------------------------------------------------------------------------------------------------------------
